import { createContext, useContext } from 'react';

const MatchContext = createContext(null);

export function useMatch() {
  return useContext(MatchContext);
}

export default MatchContext;
